"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trigger = exports.Size = void 0;
var Size = exports.Size = /*#__PURE__*/function (Size) {
  Size["DEFAULT"] = "default";
  Size["SMALL"] = "small";
  return Size;
}({});
var Trigger = exports.Trigger = /*#__PURE__*/function (Trigger) {
  Trigger["ON_TYPE"] = "on-type";
  Trigger["ON_SUBMIT"] = "on-submit";
  return Trigger;
}({});